// Helpers / Libraries:
import { Set as ImmutableSet } from 'immutable';
// @ts-expect-error module not typed
import { getCommonMessageSenderType } from 'conversations-message-history/common-message-format/operators/getCommonMessageSenderType';
// @ts-expect-error module not typed
import { getCommonMessageSenderId } from 'conversations-message-history/common-message-format/operators/getCommonMessageSenderId';
// @ts-expect-error module not typed
import { getSenderIdOrVid } from 'conversations-message-history/common-message-format/operators/getSenderIdOrVid';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { isSenderPresent } from 'conversations-message-history/senders/operators/isSenderPresent';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getFromAddress, getFromName
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error module not typed
import { senderEmailDoesNotMatchVisitor } from 'conversations-message-history/senders/operators/senderEmailDoesNotMatchVisitor';
import { getFirstName, getLastName } from 'conversations-message-history/senders/operators/getters';
import Sender from 'conversations-message-history/senders/records/Sender';
// @ts-expect-error module not typed
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';

// Components:
// @ts-expect-error module not typed
import PrimaryMessageAvatar from '../primary-message/components/PrimaryMessageAvatar';
import SenderAvatar from '../avatar/SenderAvatar';

// Types:
import { jsx as _jsx } from "react/jsx-runtime";
export const CommonMessageAvatar = ({
  message,
  onClickAvatar,
  presentSenderLocators = ImmutableSet(),
  senders,
  vid
}) => {
  const senderType = getCommonMessageSenderType({
    message
  });
  const senderId = getCommonMessageSenderId({
    message
  });
  const updatedSenderId = getSenderIdOrVid({
    message,
    vid,
    senderId
  });
  const asyncSender = findSender(updatedSenderId, senderType, senders);
  const present = isSenderPresent(updatedSenderId, senderType, presentSenderLocators);
  let sender = getData(asyncSender);
  const fromAddress = getFromAddress(message);
  if (!sender || senderEmailDoesNotMatchVisitor({
    sender,
    message
  }) ||
  // If sender object for the visitor exists but first name and last name does not exists then use
  // from address for displaying name in email header
  fromAddress && !getFirstName(sender) && !getLastName(sender)) {
    sender = Sender({
      senderType,
      firstName: getFromName(message),
      email: fromAddress || null
    });
  }
  const isLoading = isSenderLoading(asyncSender);
  return /*#__PURE__*/_jsx(PrimaryMessageAvatar, {
    children: /*#__PURE__*/_jsx(SenderAvatar, {
      onClick: onClickAvatar,
      sender: sender,
      present: present,
      isLoading: isLoading
    })
  });
};
CommonMessageAvatar.displayName = 'CommonMessageAvatar';